import { Link } from "react-router-dom";
import logoSquare from "@/assets/logo-square.png";
import logoFull from "@/assets/logo-full.png";

interface LogoProps {
  className?: string;
  variant?: "full" | "square";
  size?: "sm" | "md" | "lg";
}

const Logo = ({ className = "", variant = "full", size = "md" }: LogoProps) => {
  const sizeClasses = {
    sm: variant === "full" ? "h-8" : "h-8 w-8",
    md: variant === "full" ? "h-10" : "h-10 w-10",
    lg: variant === "full" ? "h-14" : "h-14 w-14",
  };

  return (
    <Link to="/" className={`flex items-center ${className}`}>
      <img 
        src={variant === "full" ? logoFull : logoSquare} 
        alt="Agence 8020" 
        className={`${sizeClasses[size]} object-contain`}
      />
    </Link>
  );
};

export default Logo;
